module.exports = __webpack_public_path__ + "static/media/lizard.593a8a11.ogg";